import { getStore as getLeftRailStore } from '../store/store';
import type { OfficeApp, OfficeAppData } from '../store/schema/OfficeApp';

export default function getOfficeAppData(app: OfficeApp): OfficeAppData {
    return getLeftRailStore().enabledRailItems.filter(item => item.app === app)[0];
}
